// Generated by replace-version.mjs before every serve/build — do not edit (gitignored).
import { environment } from './environment';

export const BUILD_TIME = '2026.11.04 11:40:56';

const envSuffix = environment.production ? '' : ` ${environment.envName}`;

/** Full version string: release + build time + env name (env hidden on production). */
export const APP_VERSION = `${environment.releaseVersion} ${BUILD_TIME}${envSuffix}`;
